import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '@mui/material/styles';

const ActionButton = ({ text, onClick }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <motion.button
      whileHover={{ scale: 1.05, transition: { duration: 0.2 } }}
      whileTap={{ scale: 0.95, transition: { duration: 0.1 } }}
      onClick={onClick}
      className={`
        w-52 h-11 rounded-full text-base font-bold relative overflow-hidden z-10
        ${isDarkMode ? 'bg-blue-700 text-white' : 'bg-blue-500 text-white'}
        shadow-[0_5px_15px_rgba(0,0,0,0.1)]
        before:content-[''] before:absolute before:top-0 before:left-0 before:w-0 before:h-full 
        before:rounded-full 
        ${isDarkMode 
          ? 'before:bg-gradient-to-r before:from-blue-600 before:to-blue-800'
          : 'before:bg-gradient-to-r before:from-blue-400 before:to-blue-600'
        }
        before:transition-all before:duration-700 before:ease-in-out before:z-[-1]
        hover:before:w-full focus:outline-none 
        ${isDarkMode
          ? 'focus:ring-2 focus:ring-blue-300 focus:ring-opacity-50'
          : 'focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50'
        }
      `}
    >
      <motion.span
        initial={{ y: 0 }}
        whileHover={{ y: -2 }}
        transition={{ duration: 0.2 }}
        className="relative z-10"
      >
        {text}
      </motion.span>
    </motion.button>
  );
};

export default ActionButton;
